import Moment from 'moment';

export default Moment;


//////////////////
// WEBPACK FOOTER
// ./plugins/Moment.js
// module id = ./plugins/Moment.js
// module chunks = 0 2 5